import { render } from "./AppPurchasePriceRevision.vue?vue&type=template&id=46799a0b&scoped=true&ts=true&lang=pug"
import script from "./AppPurchasePriceRevision.vue?vue&type=script&lang=ts"
export * from "./AppPurchasePriceRevision.vue?vue&type=script&lang=ts"

import "./AppPurchasePriceRevision.vue?vue&type=style&index=0&id=46799a0b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46799a0b"]])

export default __exports__